export default () => {
  return process.env.REACT_APP_WEBSOCKET_SERVER;
}